import React from 'react'
import Icon from '@ant-design/icons'
import {AntdIconProps} from '@ant-design/icons/es/components/AntdIcon'

const FaqIconSVG = () => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0'
      y='0'
      viewBox='0 0 275 200'
      xmlSpace='preserve'
      width='50px'
      height='50px'
    >
      <style>{'.prefix__st0{fill:#bac5d4}'}</style>
      <path
        className='prefix__st0'
        transform="scale(2) translate(5, 5)"
        d="M32 2C15.43 2 2 14.33 2 29c0 6.52 2.72 12.45 7.13 17.03L6 62l16.33-5.67C25.1 57.16 28.48 58 32 58c16.57 0 30-12.33 30-27S48.57 2 32 2zm0 4c13.25 0 24 9.95 24 23s-10.75 23-24 23c-3.27 0-6.48-.67-9.39-1.91l-1.05-.45-9.04 3.14 2.01-9.02-.75-.77C9.39 38.37 7 33.88 7 29c0-13.05 10.75-23 25-23zm0 14c-3.85 0-7 2.69-7 6h4c0-1.21 1.33-2 3-2s3 .79 3 2c0 2-2 2.44-3.44 3.14C29.23 30.59 28 31.76 28 34h4c0-.94 1.09-1.7 2.56-2.39C36.69 30.38 39 28.71 39 26c0-3.31-3.15-6-7-6zM30 36v4h4v-4h-4zm2 14c-1.11 0-2 .89-2 2s.89 2 2 2 2-.89 2-2-.89-2-2-2z" />
    </svg>
  )
}

export const FaqIcon = (props: AntdIconProps) => (
  <Icon component={FaqIconSVG} {...(props as any)} />
)
